import React from "react"
import { BsX } from "react-icons/bs"
import { useTranslation } from "react-i18next"
import { Rechnungsverlauf } from "../models/rechnungsverlauf"
import { eventhandlingForLists } from "../views/hooks/EventhandlingForLists"
import * as Components from "./components"
import { useStoreRechnung } from "../store"

export const Rechnungsverlaeufe: () => React.JSX.Element | null = () => {
    const { rechnungsverlauf: rechnungsverlaeufe } = useStoreRechnung("rechnungsverlauf")

    const { remove, onChange, add } = eventhandlingForLists("rechnungsverlauf", () => new Rechnungsverlauf())

    const isRemovable = rechnungsverlaeufe?.length > 1
    const { t } = useTranslation()

    return (
        <>
            {rechnungsverlaeufe &&
                rechnungsverlaeufe.map((rechnungsverlauf, idx) => (
                    <RechnunngsverlaufView
                        key={idx}
                        index={idx}
                        rechnungsverlauf={rechnungsverlauf}
                        path={"rechnungsverlauf." + idx}
                        onChange={onChange(idx)}
                        onRemove={remove(idx)}
                        isRemovable={isRemovable}
                    />
                ))}
            <Components.Row>
                <Components.Col align={Components.Align.RIGHT}>
                    <Components.Button style={Components.ButtonStyle.SECONDARY} label={t("rechnung.rechnungsverlauf.hinzufuegen")} onClick={add} />
                </Components.Col>
            </Components.Row>
        </>
    )
}

interface RechnunngsverlaufViewProps {
    index: number
    rechnungsverlauf: Rechnungsverlauf
    path: string
    onRemove: () => void
    onChange: (propertyname: string) => (value: unknown) => void
    isRemovable: boolean
}

export function RechnunngsverlaufView({ index, rechnungsverlauf, onRemove, onChange, isRemovable }: RechnunngsverlaufViewProps) {
    const { t } = useTranslation()

    return (
        <>
            <React.Fragment key={index}>
                <Components.Row>
                    <Components.Col size={5} sizeSmallDown={12}>
                        <Components.FormGroup inline={true} label={t("rechnung.rechnungsverlauf.rechnungsnummer.label")} labelClassName="small">
                            <Components.TextEdit
                                placeholder={t("rechnung.rechnungsverlauf.rechnungsnummer.placeholder")}
                                value={rechnungsverlauf.rechnungsnummer}
                                onChange={onChange("rechnungsnummer")}
                            />
                        </Components.FormGroup>
                    </Components.Col>
                    <Components.Col size={5} sizeSmallDown={12}>
                        <Components.FormGroup inline={true} label={t("rechnung.rechnungsverlauf.rechnungsdatum.label")} labelClassName="small">
                            <Components.DateEdit value={rechnungsverlauf.rechnungsdatum} onChange={onChange("rechnungsdatum")} />
                        </Components.FormGroup>
                    </Components.Col>
                    <Components.Col size={2} sizeSmallDown={12}>
                        <div className="row" style={{ marginTop: "calc(1.5em + .75rem + 2px)" }}>
                            <div>
                                {isRemovable && (
                                    <button
                                        className="btn btn-outline-secondary"
                                        type="button"
                                        onClick={onRemove}
                                        title={t("rechnung.rechnungsverlauf.loeschen")}
                                    >
                                        <BsX size={20} />
                                    </button>
                                )}
                            </div>
                        </div>
                    </Components.Col>
                </Components.Row>
            </React.Fragment>
        </>
    )
}
